import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Style from './Loader.module.scss';


// colors : 'inherit', 'primary', 'secondary', 'error', 'info', 'success', 'warning'
// size : number
// thickness: number

export const Loader = ({ color = "primary", classes = undefined, size = 40, thickness = 3.6, style = {} }) => {
  return (
    <CircularProgress
      color={color}
      size={size}
      thickness={thickness}
      classes={classes}
      style={style} />
  );
}

export const ClientCardLoader = ({ count = 1, height = 30 }) => {
  return (
    <Stack direction="row" spacing={1} >
      {[...Array(count)].map((e, i) => {
        return <div style={{width:'350px',height:'412px', padding: '1rem'}}  key={i}>
          <Skeleton variant="rectangular" width="100%" height={180} style={{borderTopLeftRadius: '0.25rem', borderTopRightRadius: '0.25rem'}}/>
          <Skeleton animation="wave" style={{ marginTop: 30 }} />
          <Skeleton animation="wave" style={{ marginTop: 10 }} />
          <Skeleton animation="wave" style={{ marginTop: 10 }} />
          <Skeleton animation="wave" style={{ marginTop: 10 }} />
        </div>  
      })}
    </Stack>
  )
}

export const TableLoader = ({ count = 1, height = 40 }) => {
  return (
    <div className={Style.table_loader_container}>
      <Stack spacing={0.3}>
        {[...Array(count)].map((e, i) => {
          return <Skeleton variant="rectangular" width="100%" height={height} key={i} />
        })}
      </Stack>
    </div>
  )
}